import React from "react";
import Select from "react-select";
import { ButtonGroup, Button, Tabs, Tab } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faChartBar, faQuestion } from "@fortawesome/free-solid-svg-icons";

import NumericLabel from "react-pretty-numbers";

import ModelTileContainer from "containers/Tiles/ModelTile";
import RunPlotContainer from "containers/RunPlot/RunPlot";
import FeatureChartContainer from "containers/FeatureChart/FeatureChart";

import styles from "./style.module.css";
import { PANEL_MODES } from "containers/Run/reducer";

export default class RightPanel extends React.PureComponent {
  render() {
    const { panelMode, className, style, children } = this.props;

    const isClosed = panelMode === PANEL_MODES.CLOSED;

    return (
      <div
        className={styles.rightPanel + (className ? " " + className : "")}
        style={{ ...style, minWidth: !isClosed ? "450px" : "0px", width: !isClosed ? "450px" : "0px" }}
      >
        {children}
      </div>
    );
  }
}

export class PanelHeader extends React.PureComponent {
  render() {
    const { className, style, children } = this.props;
    return (
      <div className={styles.rightHeader + (className ? " " + className : "")} style={{ ...style }}>
        {children}
      </div>
    );
  }
}

export class PanelBody extends React.PureComponent {
  render() {
    const { className, style, children } = this.props;
    return (
      <div className={styles.rightBody + (className ? " " + className : "")} style={{ ...style }}>
        {children}
      </div>
    );
  }
}

export class PanelFooter extends React.PureComponent {
  render() {
    const { className, style, children } = this.props;
    return (
      <div className={styles.rightFooter + (className ? " " + className : "")} style={{ ...style }}>
        {children}
      </div>
    );
  }
}
